import { BigNumber } from 'bignumber.js';
import { FRACTIONAL_DIGITS } from '~/utils/constants';

export const extractReceivedAmountFromLogs = (logs: readonly any[], eventHash: string): string => {
  const FALLBACK_VALUE = '0';

  if (!logs || logs.length === 0) {
    return FALLBACK_VALUE;
  }

  const swapLog = logs.find((log) => log.topics && log.topics[0] === eventHash);

  if (!swapLog || !swapLog.data) {
    return FALLBACK_VALUE;
  }

  const logDataHex = swapLog.data.slice(2);
  const amount0OutHex = logDataHex.slice(128, 192);
  const amount1OutHex = logDataHex.slice(192, 256);

  const amount0OutWei = BigInt('0x' + amount0OutHex);
  const amount1OutWei = BigInt('0x' + amount1OutHex);

  let receivedAmountWei;
  if (amount0OutWei > 0) {
    receivedAmountWei = amount0OutWei;
  } else if (amount1OutWei > 0) {
    receivedAmountWei = amount1OutWei;
  } else {
    return FALLBACK_VALUE;
  }

  const receivedAmountTokens = BigNumber(receivedAmountWei.toString()).dividedBy(BigNumber(10).pow(18));

  return receivedAmountTokens.toFixed(FRACTIONAL_DIGITS);
};
